import { render, staticRenderFns } from "./Setup_Staff.vue?vue&type=template&id=14c8f50c&scoped=true&"
import script from "./Setup_Staff.vue?vue&type=script&lang=js&"
export * from "./Setup_Staff.vue?vue&type=script&lang=js&"
import style0 from "./Setup_Staff.vue?vue&type=style&index=0&id=14c8f50c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c8f50c",
  null
  
)

export default component.exports